export const createJWTToken = () => {
  var jwt = require("jsonwebtoken");
  const token = jwt.sign({}, process.env.REACT_APP_API_SECRET_KEY);
  return token;
};
